import React, { useState } from "react";
import { useCollections } from "../store/CollectionContext";
import Dropdown, { DropdownOption } from "./Dropdown";
import InlineTextForm from "./InlineTextForm";

interface CollectionDropdownProps {
  selectedCollectionId: string | null;
  onSelect: (collectionId: string | null) => void;
  disabled?: boolean;
  className?: string;
}

const CollectionDropdown: React.FC<CollectionDropdownProps> = ({ selectedCollectionId, onSelect, disabled, className }) => {
  const { collections, addCollection } = useCollections();
  const [creating, setCreating] = useState(false);

  const selectedName = collections.find(c => c.id === selectedCollectionId)?.name ?? 'None';

  return (
    <Dropdown label="Collection:" selectedLabel={selectedName} disabled={disabled} className={className} onClose={() => setCreating(false)}>
      {({ close }) => (
        <>
          <DropdownOption onClick={() => { onSelect(null); close(); }}>
            <div className="text-sm text-gray-900">None</div>
          </DropdownOption>
          {collections.map(collection => (
            <DropdownOption key={collection.id} onClick={() => { onSelect(collection.id); close(); }}>
              <div className="text-sm text-gray-900">{collection.name}</div>
            </DropdownOption>
          ))}
          {creating ? (
            <div className="px-3 py-2">
              <InlineTextForm
                placeholder="Collection name"
                inputClassName="flex-1 min-w-0"
                onConfirm={async (name) => {
                  const collection = await addCollection(name);
                  onSelect(collection.id);
                  setCreating(false);
                  close();
                }}
                onCancel={() => setCreating(false)}
              />
            </div>
          ) : (
            <DropdownOption onClick={() => setCreating(true)}>
              <div className="text-sm text-gray-900">+ New Collection</div>
            </DropdownOption>
          )}
        </>
      )}
    </Dropdown>
  )
};

export default CollectionDropdown;
